import i18n from 'modules/core/lib/i18n'

export interface NewTrainingFormValues {
  name: string
  code: string
  description: string
  external: boolean
  externalProvider: string
  cost?: number
  subsidizedCost?: number
  costDecimal: string
  subsidizedCostDecimal: string
  categoryIds: number[]
  competencyIds: number[]
  year: number
  attachments: []
}

const externalValue = 'external'
const internalValue = 'internal'
// Returs the options for the training type selector
export const externalOptions = () => {
  return [
    {
      label: i18n.t('trainings.create_training_modal.external_options.internal'),
      value: internalValue,
    },
    {
      label: i18n.t('trainings.create_training_modal.external_options.external'),
      value: externalValue,
    },
  ]
}

// Converts the boolean value used by the training model
// to the string value used by the UI
export const externalBoolToString = (value: boolean): string => {
  return value ? externalValue : internalValue
}

// Converts the string value used by the UI
// to the boolean value used by the training model
export const externalStringToBool = (value: string): boolean => {
  return value === externalValue
}
